export default "__VITE_ASSET__BIvTySmh__"